import React from 'react'

import classes from './careers.module.scss'
import Layout from '../components/layouts/layout'
import BasicPageHeading from '../components/basic-page-heading'
import {combine} from '../styles/classname-utils'


const JobList = ({jobs}) => (
  <ul className={classes.jobList}>
    {jobs?.map(j => (
      <li key={j.id}><a className='text8-md' href={j.absolute_url}>{j.title}</a></li>
    ))}
    {(!jobs || jobs.length === 0) && <li>No openings currently available</li>}
  </ul>
)

export default () => {
  const [jobsByDepartment, setJobsByDepartment] = React.useState({})

  const URL = 'https://boards-api.greenhouse.io/v1/boards/niantic8thwall/departments'
  React.useEffect(() => {
    fetch(URL)
      .then((response) => {
        if (response.ok) {
          return response.json()
        } else {
          throw new Error(`HTTP Error ${response.status}`)
        }
      })
      .then((obj) => {
        const findJobs = obj.departments.reduce((out, department) => {
          if (department.jobs.length > 0) {
            out[department.name] = department.jobs
          }
          return out
        }, {})
        setJobsByDepartment(findJobs)
      })
  }, [])

  return (
    <Layout
      title='Careers - Join Our Team! Hiring Software Engineers, Designers, XR Jobs'
      description='8th Wall is hiring! Join our innovative team of AR software engineers, designers and product managers. Explore open roles for a job in WebAR.'
    >
      <BasicPageHeading>
        Careers
      </BasicPageHeading>
      <section className='light'>
        <div className='row justify-content-center'>
          <div className='col-lg-8 col-md-10 col-12 max-width'>
            <h2 className='text-center'>
              Join the 8th Wall team!
            </h2>
            <p className='text8-md'>
              At 8th Wall, we believe that augmented reality is for everyone. We’re breaking
              barriers between the digital and physical, and bridging the development gap between
              iOS and Android, so that anyone can experience the magic of AR&mdash;no matter what
              device they’re on. With a dream team of computer vision engineers, designers and
              tinkerers at the helm, we care deeply about creating the tools for creative developers
              to make no-compromise immersive content for everyone to enjoy.
            </p>
          </div>
        </div>
      </section>
      <section>
        <div className='row justify-content-center'>
          <div className='col-lg-8 col-md-10 col-12 max-width'>
            {Object.keys(jobsByDepartment).map(deptName => (
              <div key={deptName} className={classes.dept}>
                <h3 className={combine('font8-black', classes.deptName)}>{deptName}</h3>
                <JobList jobs={jobsByDepartment[deptName]} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  )
}
